import { Routes, Route, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import DynamicGamePage from './pages/DynamicGamePage';
import AdminPage from './pages/AdminPage';
import AdminCreatorPage from './pages/AdminCreatorPage';
import AdminFactoryPage from './pages/AdminFactoryPage';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <h1>AI Daily Game Factory</h1>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/games">Games</Link>
          <Link to="/admin/games">Admin</Link>
          <Link to="/admin/creator">Creator</Link>
          <Link to="/admin/factory">Factory</Link>
        </nav>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* M0 legacy route - hardcoded demo game */}
          <Route path="/games/:slug" element={<GamePage />} />
          <Route path="/games" element={<HomePage />} />
          {/* M1 dynamic route - loads games via registry */}
          <Route path="/game/:slug" element={<DynamicGamePage />} />
          {/* M1 admin dashboard */}
          <Route path="/admin/games" element={<AdminPage />} />
          {/* M2 AI creator admin */}
          <Route path="/admin/creator" element={<AdminCreatorPage />} />
          {/* M3 daily factory auto-production pipeline */}
          <Route path="/admin/factory" element={<AdminFactoryPage />} />
        </Routes>
      </main>
      <footer className="app-footer">
        AI Daily Game Factory &mdash; M3.2 &mdash; Open Source &middot; Zero Budget
      </footer>
    </div>
  );
}

export default App;
